import { cloudPalette } from './cloud.palette';
import type { PaletteColorName } from './color.types';
import { daylightPalette } from './daylight.palette';
import { joyfulPalette } from './joyful.palette';
import { plumPalette } from './plum.palette';
import { primaryPalette } from './primary.palette';
import { professionalPalette } from './professional.palette';
import { sunsetPalette } from './sunset.palette';

// Append new palettes rather than inserting: a couple of tests address these
// positionally (COLOR_PALETTES[0] is joyful, [1] professional), so reordering
// silently repoints them.
//
// Royal was retired here — plum is its designed successor and ships three of
// royal's own accents. Experiences that persisted "royal" are aliased forward
// by RETIRED_PALETTE_IDS in lib/paletteLookup.
export const COLOR_PALETTES = [
  joyfulPalette,
  professionalPalette,
  primaryPalette,
  plumPalette,
  sunsetPalette,
  daylightPalette,
  cloudPalette,
] as const;

export const DEFAULT_PALETTE_ID = 'joyful';

// `colors` also carries the top-level gray/cool/warm neutral bundle, so filter
// down to the colorN slots rather than taking every key.
export const PALETTE_COLOR_NAMES = Object.keys(joyfulPalette.colors).filter(
  (key): key is PaletteColorName => key.startsWith('color')
);
